import { useCallback, useState } from 'react';

/**
 * Shared 'named boolean flags' loading-state pattern used across the admin
 * panels — one flag per async operation, e.g. { loadUsers: false, createUser: false }.
 */
export type LoadingStates = Record<string, boolean>;

export type SetLoading = (operation: string, isLoading: boolean) => void;

export type UseLoadingStatesResult = [LoadingStates, SetLoading];

export function useLoadingStates(initialState: LoadingStates): UseLoadingStatesResult {
  const [loadingStates, setLoadingStates] = useState<LoadingStates>(initialState);

  const setLoading = useCallback<SetLoading>((operation, isLoading) => {
    setLoadingStates((prev) => ({ ...prev, [operation]: isLoading }));
  }, []);

  return [loadingStates, setLoading];
}

export default useLoadingStates;
